module.exports = __webpack_public_path__ + "static/media/stunned.d4899f67.png";